import { render, staticRenderFns } from "./CustomersAuthorizationControl.vue?vue&type=template&id=260c665c&scoped=true"
import script from "./CustomersAuthorizationControl.vue?vue&type=script&lang=js"
export * from "./CustomersAuthorizationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c665c",
  null
  
)

export default component.exports